import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6a6d53c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row justify-content-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Create User")
  ])
], -1))
const _hoisted_4 = { class: "col-5 mt-4" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Full Name", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Personal" }, "Personal ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Bussiness" }, "Business ", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Account Type", -1))
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Business name", -1))
const _hoisted_14 = { class: "form-floating" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Phone", -1))
const _hoisted_16 = { class: "form-floating" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Email address", -1))
const _hoisted_18 = { class: "form-floating" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Role", -1))
const _hoisted_21 = { class: "form-floating" }
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Country", -1))
const _hoisted_24 = { class: "form-floating" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingPassword" }, "Password", -1))
const _hoisted_26 = { class: "form-floating" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingPassword" }, "Confirm Password", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.full_name) = $event)),
              class: "form-control",
              placeholder: "Full Name",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.full_name]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.account_type) = $event)),
              class: "form-control",
              required: ""
            }, _hoisted_10, 512), [
              [_vModelSelect, $setup.form.account_type]
            ]),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.bussiness_name) = $event)),
              type: "text",
              class: "form-control",
              placeholder: "business name"
            }, null, 512), [
              [_vModelText, $setup.form.bussiness_name]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phone) = $event)),
              class: "form-control",
              placeholder: "Phone",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.phone]
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.email) = $event)),
              class: "form-control",
              placeholder: "Email",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.email]
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.role_id) = $event)),
              class: "form-control",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.roles, (role) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: role.id,
                  value: role.id
                }, _toDisplayString(role.name), 9, _hoisted_19))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.form.role_id]
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.country_id) = $event)),
              class: "form-control",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: country.id,
                  value: country.id
                }, _toDisplayString(country.name), 9, _hoisted_22))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.form.country_id]
            ]),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.password) = $event)),
              class: "form-control",
              placeholder: "Password",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.password]
            ]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.password_confirm) = $event)),
              class: "form-control",
              placeholder: "Confirm Password",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.password_confirm]
            ]),
            _hoisted_27
          ]),
          _hoisted_28
        ], 32)
      ])
    ])
  ]))
}